export enum CalculatorType {
  NotSelected,
  FreezingEggsOrEmbryos,
  IVF,
  Surrogacy,
}
